'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export function useWindowScroll(onScroll) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      x: 0,
      y: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [scrollPosition, setScrollPosition] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== onScroll) {
    t1 = () => {
      const handleScroll = () => {
        const newPosition = {
          x: window.scrollX,
          y: window.scrollY
        };
        setScrollPosition(newPosition);
        if (onScroll) {
          onScroll(newPosition);
        }
      };
      handleScroll();
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
    t2 = [onScroll];
    $[1] = onScroll;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return scrollPosition;
}